import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { ArrowsLeftRight } from "@gaming/xds-react-js-icons";

import { useStrings } from "../../../localization/localizationHelpers";

export const ArrowsLeftRightIcon = () => {
  const [leftRightIcon] = useStrings("leftRightIcon");
  return <Icon title={leftRightIcon} icon={ArrowsLeftRight} iconSize={IconSize.Custom} />;
};
